import Cookies from 'js-cookie'

import React from 'react'
import { captureException } from '@sentry/react'

import { AUTH_SUCCESSFUL_KEY } from '@probatix/common/services/toolkit/auth/auth.constants'
import { isLocaleSupported } from '@probatix/common/utils/data'

import i18n from '@probatix/myprobatix/translations'

import Catch from './Catch'

type Props = {
  children: React.ReactNode
}

const ErrorBoundary = Catch((props: Props, error?: Error) => {
  if (error) {
    captureException(error)
  }

  if (error && (null === Cookies.get(AUTH_SUCCESSFUL_KEY))) {
    // window.location.href = '/en'
    const urlLocale = i18n.language
    if (!isLocaleSupported(urlLocale)) {
      window.location.href = `/${urlLocale}`
    }

    return <span />
  }

  return props.children
})

export default ErrorBoundary
